import React from "react";

const PromptExamples = () => {
    return <div className="mt-4 space-y-3">
            <p className="text-sm text-gray-600">Example prompts to help you get started:</p>
            <div className="space-y-2">
                <div className="p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700">
                    "Talk about the history of ancient civilizations, focusing on their most fascinating inventions and discoveries"
                </div>
                <div className="p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700">
                    "Share daily productivity tips and life hacks that can help people save time and be more efficient"
                </div>
                <div className="p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700">
                    "Fast-forward to the year 2035. Show futuristic AI robots, self-driving cities, and mind-blowing technology reshaping everyday life"
                </div>
                <div className="p-3 bg-gray-50 border border-gray-200 rounded-lg text-sm text-gray-700">
                    "Explore eerie locations like the Bermuda Triangle, abandoned ghost towns, or the Door to Hell in Turkmenistan"
                </div>
            </div>
        </div>

};
export default PromptExamples
